var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9999 4.84999C3.36934 4.84999 2.8499 5.36944 2.8499 5.99999V18C2.8499 18.6306 3.36934 19.15 3.9999 19.15H19.9999C20.6305 19.15 21.1499 18.6306 21.1499 18V5.99999C21.1499 5.36944 20.6305 4.84999 19.9999 4.84999H3.9999ZM1.1499 5.99999C1.1499 4.43055 2.43046 3.14999 3.9999 3.14999H19.9999C21.5693 3.14999 22.8499 4.43055 22.8499 5.99999V18C22.8499 19.5694 21.5693 20.85 19.9999 20.85H3.9999C2.43046 20.85 1.1499 19.5694 1.1499 18V5.99999Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30363 5.51256C1.57284 5.12797 2.10284 5.03444 2.48742 5.30365L12 11.9624L21.5125 5.30365C21.8971 5.03444 22.4271 5.12797 22.6963 5.51256C22.9655 5.89714 22.872 6.42714 22.4874 6.69635L12.4874 13.6963C12.1947 13.9012 11.8052 13.9012 11.5125 13.6963L1.51253 6.69635C1.12795 6.42714 1.03442 5.89714 1.30363 5.51256Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailActive);
export default __webpack_public_path__ + "static/media/mail-active.f3504c3e1c580c4c136325bca7f7624b.svg";
export { ForwardRef as ReactComponent };